export const getInvitingCode = (location) => {
  const hasInvitingCode = location.pathname.includes('/inviting_code=')
  const invitingCode = hasInvitingCode ? location.pathname.slice(15) : null

  return { hasInvitingCode, invitingCode }
}
